<template>
  <el-select
    v-model="val"
    :placeholder="placeholder"
    :size="size"
    :disabled="disabled"
    :clearable="clearable"
    :style="config.style"
    :multiple="multiple"
    @change="change"
    :filterable="filterable"
  >
    <el-option
      v-for="opt in opts"
      :key="opt[props.valueField]"
      :value="opt[props.valueField]"
      :label="opt[props.labelField]"
    />
  </el-select>
</template>

<script>
import emitter from 'element-ui/src/mixins/emitter'
import { getCMDictByTableCodeApi, getAYDictByTableCodeApi } from "@/util/api.js";

export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  mixins: [emitter],
  props: {
    value: String,
    tableCode: String,
    tableType: {
      type: String,
      default: 'cm'
    },
    lazy: false,
    multiple: false,
    disabled: false,
    clearable: {
      type: Boolean,
      default: true
    },
    filterable: true,
    options: [Array, Object],
    includeKeys: Array,
    excludeKeys: Array,
    props: {
      type: Object,
      default: function() {
        return {
          root: "responseData",
          valueField: "valueCode",
          labelField: "valueName"
        }
      }
    },
    emptyText: String,
    placeholder: {
      type: String,
      default: "请选择"
    },
    config: {
      type: Object,
      default: function() {
        return {}
      }
    },
    size: {
      type: String,
      default: 'small'
    }
  },
  data: function() {
    return {
      val: this.value,
      opts: []
    }
  },
  computed: {},
  watch: {
    value: {
      handler: function(value) {
        if (this.val != value) {
          this.val = value
        }
      }
    },
    options: {
      deep: true,
      handler (val) {
        this.opts = val;
      }
    }
  },
  mounted: function() {
    this.compose()
  },
  methods: {
    getOption: function () {
      let opt = this.opts.find((item) => {
        return item[this.props.valueField] === this.value
      })
      return opt
    },
    change: function(val) {
      this.dispatch('ElFormItem', 'el.form.change', val);
      this.dispatch('ElFormItem', 'el.form.blur', val);
      this.$emit("change", this.val || null)
    },
    requestUrl: function() {
      if (this.tableType == 'cm') {
        return getCMDictByTableCodeApi({
            tableCode: this.tableCode
        })
      } else {
        return getAYDictByTableCodeApi({
            tableCode: this.tableCode
        })
      }
    },
    compose: async function() {
      let opts = []
      if (this.emptyText) {
        opts.push({
          [this.props.valueField]: "",
          [this.props.labelField]: this.emptyText
        })
      }
      let parse = function(options) {
        let opts = []
        if (options) {
          if (Array.isArray(options)) {
            opts = [...options]
          } else if (typeof options === "object") {
            for (let key in options) {
              opts.push({
                [this.props.valueField]: key,
                [this.props.labelField]: options[key]
              })
            }
          }
        }
        return opts
      }
      if (this.options) {
        opts = [...parse(this.options)]
      }
      if (this.lazy) {
        let res = await this.requestUrl()
        opts = opts.concat(parse(res[this.props.root]))
      }
      if (this.includeKeys) {
        opts = opts.filter((opt) => {
          return this.includeKeys.indexOf(opt[this.props.valueField]) !== -1
        })
      }
      if (this.excludeKeys) {
        opts = opts.filter((opt) => {
          return this.excludeKeys.indexOf(opt[this.props.valueField]) === -1
        })
      }
      this.opts = opts
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/business/DictionarySelect.vue